module.exports = {"create_costs_informs":"Crear informe de costos","date_range":"Rang de dates","inform_name":"Nom de l'informe","model_device":"Model Disp.","select_model":"Tria Model","device":"Dispositiu","create":"Crear","costs_inform":"Informe de costos"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/CostsInform.json
// module id = 585
// module chunks = 1